import { cosemApi } from '@services/providers/cosem';
import { ApiResponse } from '@services/providers/cosem.types';
import { DashboardData, DashboardChart } from './dashboard.types';

const dashboardApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getDashboardData: build.mutation<ApiResponse<DashboardData>, undefined>({
            query: () => {
                return { 
                    url: `/product/dashboard/data`, 
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<DashboardData>) => response
        }),
        getDashboardChart: build.mutation<ApiResponse<DashboardChart>, { startDate: string, endDate: string }>({
            query: ({ startDate, endDate }: { startDate: string, endDate: string }) => {
                return { 
                    url: `/product/dashboard/chart`, 
                    method: 'GET',
                    params: { startDate, endDate }
                };
            },
            transformResponse: (response: ApiResponse<DashboardChart>) => response
        })
    })
});

export const { 
    useGetDashboardDataMutation,
    useGetDashboardChartMutation
} = dashboardApi;
